<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="WalletBalance" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import { WalletBalanceProps } from './WalletBalance.ts';
import WalletBalance from './WalletBalance.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-wallet-balance';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<WalletBalanceProps>();
const changableProps = useChangableProps(componentName, props);

</script>
